import {
  listTaxonomies
} from '@/services/taxonomies.service'

const actions = {
  async fetchTaxonomies(_context, { depth, taxonomyPath = null } ) {
    const response = await listTaxonomies({ depth, taxonomy_path: taxonomyPath });
    return response;
  },
}

export default actions;
